export enum UserCreatedBy {
  WALLET = 'WALLET',
  ADMIN = 'ADMIN',
  SSO = 'SSO',
  SIGNUP = 'SIGNUP',
}
